import { render, staticRenderFns } from "./PasswordResetEnrollCard.vue?vue&type=template&id=9e97efee&scoped=true"
import script from "./PasswordResetEnrollCard.vue?vue&type=script&lang=js"
export * from "./PasswordResetEnrollCard.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetEnrollCard.vue?vue&type=style&index=0&id=9e97efee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e97efee",
  null
  
)

export default component.exports